import { AlertSeverity } from '@rover/react-lib/src/components/notifications/Alert/Alert';
import {
  getIsPriceTransparency,
  getIsPriceTransparencyCondensed,
  getIsPriceTransparencyFull,
} from '@rover/utilities/priceTransparency';

import {
  AlertContentEnum,
  getAlertContent,
  getSubHeader,
  HEADER_TITLES,
  HeaderIconEnum,
  HeaderTitlesEnum,
  SubHeadersEnum,
} from './constants';
import { BestMatchBuilderProps, PrebuiltHeaderProps } from './types';

const buildBestMatchesHeader = (props: BestMatchBuilderProps): PrebuiltHeaderProps | object => {
  const { startDate, endDate } = props.dateData;
  const hasDates = !!startDate && !!endDate;
  const isPriceTransparency = getIsPriceTransparency(props.priceTransparencyLevel);
  const isPtCondensed = getIsPriceTransparencyCondensed(props.priceTransparencyLevel);

  let primarySubheader: string | undefined;
  let secondarySubheader: string | undefined;
  let alertText: string | undefined;

  if (isPriceTransparency && !isPtCondensed) {
    if (props.hasBestMatches) {
      primarySubheader = getSubHeader(SubHeadersEnum.BEST_MATCH_LIST_SHORT_LEAD_TIME, props);
    }

    if (getIsPriceTransparencyFull(props.priceTransparencyLevel)) {
      alertText = hasDates
        ? getAlertContent(AlertContentEnum.PRICE_TRANSPARENCY_FULL_PRICES_FOR_UNIT, props)
        : getAlertContent(AlertContentEnum.PRICE_TRANSPARENCY_FULL_ADD_DATES, props);
    }
  } else {
    primarySubheader = hasDates
      ? getSubHeader(SubHeadersEnum.SEEING_PROVIDERS_DATES, props)
      : getSubHeader(SubHeadersEnum.ADD_DATES, props);

    if (props.hasBestMatches) {
      secondarySubheader = getSubHeader(SubHeadersEnum.BEST_MATCH_LIST_SHORT_LEAD_TIME, props);
    }
  }

  return {
    icon: HeaderIconEnum.BOLT,
    title: HEADER_TITLES()[HeaderTitlesEnum.BEST_MATCHES],
    primarySubheader,
    secondarySubheader,
    alertText,
    alertSeverity: AlertSeverity.INFO,
    isBestMatchHeader: true,
  };
};

export default buildBestMatchesHeader;
